import qs from 'qs';

export const parseQueryString = (str) => qs.parse(str, { ignoreQueryPrefix: true });
